/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import { defineComponent, h } from 'vue';
import { u as utils } from './_chunks/dep-680ea5a1.js';
import { refLineProps } from './props.js';
import { refLineTypes } from './constant.js';
import mean from './utils/mean.js';
import './utils/min.js';
import './utils/max.js';
import './utils/midRange.js';
import './utils/median.js';
import './utils/stdev.js';
import './utils/variance.js';
import './utils/dataToPoints.js';
import './utils/debounce.js';
import './utils/genColor.js';
import './utils/uid.js';
import './utils/isEmpty.js';
import '@babel/runtime/helpers/defineProperty';

var RefLine = defineComponent({
  inheritAttrs: false,
  props: refLineProps,
  render: function render() {
    var points = this.points,
        refLineType = this.refLineType,
        refLineProps = this.refLineProps,
        refLineStyles = this.refLineStyles;
    var ypoints = points.map(function (p) {
      return p.y;
    });
    var type = "mean";

    if (typeof refLineType === "string" && refLineTypes.includes(refLineType)) {
      if (refLineType === "max") {
        type = "min";
      } else if (refLineType === "min") {
        type = "max";
      } else {
        type = refLineType;
      }
    }

    var y = type === "custom" ? refLineProps && refLineProps.value || mean(ypoints) : utils[type](ypoints);
    refLineStyles["shape-rendering"] = "crispEdges";
    return h("line", {
      style: refLineStyles,
      x1: points[0].x,
      y1: y,
      x2: points[points.length - 1].x,
      y2: y
    });
  }
});

export { RefLine as default };
//# sourceMappingURL=RefLine.js.map
